/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Tunnel_OffInputs */

const en_serve_tunnel_off = /** @type {(inputs: Serve_Tunnel_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`phone preview not connected`)
};

const id_serve_tunnel_off = /** @type {(inputs: Serve_Tunnel_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tampilan HP belum tersambung`)
};

/**
* | output |
* | --- |
* | "phone preview not connected" |
*
* @param {Serve_Tunnel_OffInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_tunnel_off = /** @type {((inputs?: Serve_Tunnel_OffInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Tunnel_OffInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_tunnel_off(inputs)
	return en_serve_tunnel_off(inputs)
});